<template>
    <b-modal
        :id="id"
        v-model="modal_show"
        centered
        hide-header
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        dialog-class="welcome_modal_dialog"
        content-class="welcome_modal_content"
    >
        <div class="welcome_modal">
            <div class="welcome_modal_figure">
                <svg viewBox="0 0 160 160" class="welcome_modal_svg">
                    <circle cx="80" cy="80" r="78" fill="#F9F1E7"/>
                    <circle cx="22" cy="28" r="4" fill="#78420C" opacity="0.45"/>
                    <circle cx="141" cy="42" r="5" fill="#C99760" opacity="0.6"/>
                    <circle cx="28" cy="128" r="4" fill="#C99760" opacity="0.6"/>
                    <circle cx="136" cy="118" r="4" fill="#78420C" opacity="0.4"/>
                    <rect x="112" y="22" width="7" height="7" rx="1.5" fill="#78420C" opacity="0.5" transform="rotate(20 115.5 25.5)"/>
                    <rect x="14" y="108" width="6" height="6" rx="1.5" fill="#78420C" opacity="0.4" transform="rotate(-15 17 111)"/>

                    <ellipse cx="42" cy="80" rx="24" ry="30" fill="#A9713F"/>
                    <ellipse cx="118" cy="80" rx="24" ry="30" fill="#A9713F"/>
                    <ellipse cx="42" cy="80" rx="14" ry="20" fill="#C99760"/>
                    <ellipse cx="118" cy="80" rx="14" ry="20" fill="#C99760"/>

                    <circle cx="80" cy="76" r="40" fill="#78420C"/>
                    <path d="M65 101 Q59 130 77 139 Q92 145 88 129" stroke="#78420C" stroke-width="16" fill="none" stroke-linecap="round"/>

                    <path d="M61 69 Q66 63 71 69" stroke="#FFFFFF" stroke-width="3" fill="none" stroke-linecap="round"/>
                    <path d="M89 69 Q94 63 99 69" stroke="#FFFFFF" stroke-width="3" fill="none" stroke-linecap="round"/>
                    <circle cx="58" cy="83" r="5" fill="#E8A9A9" opacity="0.5"/>
                    <circle cx="102" cy="83" r="5" fill="#E8A9A9" opacity="0.5"/>
                </svg>
            </div>
            <h3 class="welcome_modal_title">{{ title }}</h3>
            <p class="welcome_modal_text" v-html="text"></p>
            <button class="btn btn_md btn_brown welcome_modal_btn" @click="fn_confirm">{{ btnText }}</button>
        </div>
    </b-modal>
</template>

<script>
    export default {
        props: {
            id: {
                type: String,
                default: 'joinWelcomeModal'
            },
            isShow: Boolean,
            title: {
                type: String,
                default: '가입을 환영합니다!'
            },
            text: {
                type: String,
                default: ''
            },
            btnText: {
                type: String,
                default: '확인'
            }
        },
        computed: {
            modal_show: {
                get() {
                    return this.isShow;
                },
                set(newVal) {
                    this.$emit('update:showSetting', newVal);
                }
            }
        },
        methods: {
            fn_confirm() {
                this.modal_show = false;
                this.$emit('confirm');
            }
        }
    }
</script>

<style scoped>
.welcome_modal_dialog >>> .modal-content {
    border: none;
    border-radius: 20px;
    box-shadow: 0 10px 40px rgba(46, 4, 1, 0.18);
    overflow: hidden;
}
.welcome_modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 20px 10px 30px;
}
.welcome_modal_figure {
    width: 140px;
    height: 140px;
    animation: welcome_pop .5s cubic-bezier(.34,1.56,.64,1);
}
.welcome_modal_svg {
    width: 100%;
    height: 100%;
}
.welcome_modal_title {
    margin-top: 18px;
    font-size: 22px;
    font-weight: 700;
    color: #2E0401;
}
.welcome_modal_text {
    margin-top: 10px;
    font-size: 15px;
    line-height: 1.6;
    color: #6b5c4d;
    white-space: pre-line;
}
.welcome_modal_btn {
    margin-top: 24px;
    min-width: 140px;
}
@keyframes welcome_pop {
    0% {
        opacity: 0;
        transform: scale(.6);
    }
    100% {
        opacity: 1;
        transform: scale(1);
    }
}
</style>